import { formatDateLabel } from "../../../utils/date.util";

export const ActiveChatDateLabel = ({ date }: { date: Date }) => {
  const dateLabel = formatDateLabel(date);
  return <div className="mx-auto  w-max py-2 my-2 px-4 bg-white rounded-md text-sm  text-gray-600 ">{dateLabel}</div>;
};
